
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalPluggedNoCharge25 as ObiBatteryHorizontalPluggedNoCharge25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-plugged-no-charge-25.js';
 
 
 

 
 export const ObiBatteryHorizontalPluggedNoCharge25 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-plugged-no-charge-25',
   elementClass: ObiBatteryHorizontalPluggedNoCharge25Element,
   events: {
     
   }
  });
 
 